import { Plugins } from '@leverege/plugin';
const getViewsFor = type => {
  const processor = views => {
    return views.filter(plg => {
      const {
        model
      } = plg;
      if (model.resultType == null) {
        return true;
      }
      if (typeof model.resultType === 'string') {
        return model.resultType === type;
      }
      if (Array.isArray(model.resultType)) {
        return model.resultType.includes(type);
      }
      return false;
    }).map(view => {
      const {
        model
      } = view;
      return {
        name: model.DISPLAY_NAME,
        value: model.TYPE
      };
    });
  };
  return Plugins.createView('AggViewModel', {
    processor,
    name: type
  }).get();
};
export default {
  getViewsFor
};